import { render, staticRenderFns } from "./Box14.vue?vue&type=template&id=f0ac8b6e&scoped=true&"
import script from "./Box14.vue?vue&type=script&lang=js&"
export * from "./Box14.vue?vue&type=script&lang=js&"
import style0 from "./Box14.vue?vue&type=style&index=0&id=f0ac8b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ac8b6e",
  null
  
)

export default component.exports